import React, { Component } from "react";
import { Modal, Form, Row, Col } from "react-bootstrap";
import "./_transportManagement.scss";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
// firebase removed — live transport tracking disabled
// import { subscribeLiveBuses, subscribeTransportData } from "../../../transportFirebase";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const SCHOOL_LAT = 17.4688;
const SCHOOL_LNG = 78.3513;
const OSRM_BASE  = "https://router.project-osrm.org/route/v1/driving";
const TICK_MS    = 2000;
const ADVANCE    = 0.0015; // fraction of route per tick → full simulated trip ≈ 22 min

const BUS_COLORS = ["#10b981","#3b82f6","#f59e0b","#8b5cf6","#ef4444","#06b6d4","#f97316"];

// Stagger initial positions so buses look spread across their routes
const INIT_PROGRESS = { 1: 0.38, 2: 0.22, 3: 0.12, 4: 0.45, 5: 0.62, 6: 0.30, 7: 0.18 };

const SAMPLE_ROUTES = [
  {
    id: 1, name: "Route 1 — KPHB Colony", busNumber: "TS-09-CA-1234",
    driver: "Ram Swaroop", driverPhone: "9876543210", departure: "7:00 AM", status: "On time",
    stops: [
      { order: 1, name: "KPHB Phase 7",        lat: 17.5030, lng: 78.3902, time: "6:30 AM", students: 10 },
      { order: 2, name: "KPHB Phase 3",         lat: 17.4985, lng: 78.3875, time: "6:35 AM", students: 12 },
      { order: 3, name: "JNTU Gate",            lat: 17.4933, lng: 78.3852, time: "6:40 AM", students: 8  },
      { order: 4, name: "Nizampet X Roads",     lat: 17.4895, lng: 78.3815, time: "6:47 AM", students: 11 },
      { order: 5, name: "Chandanagar Junction", lat: 17.4783, lng: 78.3690, time: "6:58 AM", students: 7  },
      { order: 6, name: "Lingampally Station",  lat: 17.4738, lng: 78.3618, time: "7:05 AM", students: 8  },
      { order: 7, name: "Hafeezpet",            lat: 17.4714, lng: 78.3574, time: "7:10 AM", students: 9  },
      { order: 8, name: "School",               lat: SCHOOL_LAT, lng: SCHOOL_LNG, time: "7:20 AM", students: 0 },
    ],
  },
  {
    id: 2, name: "Route 2 — Madhapur", busNumber: "TS-09-CB-5678",
    driver: "Mahesh Singh", driverPhone: "9876543211", departure: "7:10 AM", status: "On time",
    stops: [
      { order: 1, name: "Madhapur Main Road",   lat: 17.4486, lng: 78.3908, time: "6:40 AM", students: 14 },
      { order: 2, name: "Durgam Cheruvu",       lat: 17.4518, lng: 78.3741, time: "6:50 AM", students: 10 },
      { order: 3, name: "Shilparamam",          lat: 17.4553, lng: 78.3680, time: "6:56 AM", students: 11 },
      { order: 4, name: "Hi-Tech City Station", lat: 17.4541, lng: 78.3618, time: "7:03 AM", students: 9  },
      { order: 5, name: "Inorbit Mall",         lat: 17.4580, lng: 78.3572, time: "7:09 AM", students: 12 },
      { order: 6, name: "School",               lat: SCHOOL_LAT, lng: SCHOOL_LNG, time: "7:20 AM", students: 0 },
    ],
  },
  {
    id: 3, name: "Route 3 — Gachibowli", busNumber: "TS-09-CC-9012",
    driver: "Suresh Kumar", driverPhone: "9876543212", departure: "6:45 AM", status: "Delayed 10min",
    stops: [
      { order: 1,  name: "DLF Cyber City",      lat: 17.4401, lng: 78.3489, time: "6:00 AM", students: 9  },
      { order: 2,  name: "Gachibowli Stadium",  lat: 17.4418, lng: 78.3542, time: "6:07 AM", students: 8  },
      { order: 3,  name: "ISB Road",            lat: 17.4445, lng: 78.3598, time: "6:13 AM", students: 7  },
      { order: 4,  name: "Financial District",  lat: 17.4468, lng: 78.3645, time: "6:19 AM", students: 10 },
      { order: 5,  name: "Narsingi",            lat: 17.4502, lng: 78.3500, time: "6:28 AM", students: 9  },
      { order: 6,  name: "Puppalaguda",         lat: 17.4532, lng: 78.3472, time: "6:34 AM", students: 7  },
      { order: 7,  name: "Manikonda Junction",  lat: 17.4563, lng: 78.3490, time: "6:40 AM", students: 8  },
      { order: 8,  name: "Whitefields Colony",  lat: 17.4612, lng: 78.3499, time: "6:46 AM", students: 9  },
      { order: 9,  name: "Srinivasa Nagar",     lat: 17.4648, lng: 78.3505, time: "6:52 AM", students: 8  },
      { order: 10, name: "School",              lat: SCHOOL_LAT, lng: SCHOOL_LNG, time: "7:00 AM", students: 0 },
    ],
  },
  {
    id: 4, name: "Route 4 — Miyapur", busNumber: "TS-09-CE-3456",
    driver: "Ravi Verma", driverPhone: "9876543213", departure: "7:15 AM", status: "On time",
    stops: [
      { order: 1, name: "Miyapur Metro",   lat: 17.4959, lng: 78.3418, time: "6:45 AM", students: 15 },
      { order: 2, name: "Allwyn Colony",   lat: 17.4905, lng: 78.3450, time: "6:52 AM", students: 11 },
      { order: 3, name: "Chanda Nagar",   lat: 17.4862, lng: 78.3510, time: "6:58 AM", students: 9  },
      { order: 4, name: "Suraram Colony", lat: 17.4800, lng: 78.3492, time: "7:05 AM", students: 8  },
      { order: 5, name: "School",         lat: SCHOOL_LAT, lng: SCHOOL_LNG, time: "7:20 AM", students: 0 },
    ],
  },
  {
    id: 5, name: "Route 5 — Hitec City", busNumber: "TS-09-CF-7890",
    driver: "Vijay Sharma", driverPhone: "9876543214", departure: "6:30 AM", status: "On time",
    stops: [
      { order: 1,  name: "Hitec City Bus Depot", lat: 17.4453, lng: 78.3772, time: "6:00 AM", students: 8  },
      { order: 2,  name: "Raheja Mindspace",     lat: 17.4490, lng: 78.3700, time: "6:07 AM", students: 7  },
      { order: 3,  name: "Whitefields IT Park",  lat: 17.4510, lng: 78.3665, time: "6:13 AM", students: 9  },
      { order: 4,  name: "Mindspace Junction",  lat: 17.4540, lng: 78.3615, time: "6:19 AM", students: 8  },
      { order: 5,  name: "Patel Nagar",         lat: 17.4558, lng: 78.3585, time: "6:25 AM", students: 10 },
      { order: 6,  name: "Serilingampally",     lat: 17.4588, lng: 78.3555, time: "6:31 AM", students: 9  },
      { order: 7,  name: "Nallagandla",         lat: 17.4618, lng: 78.3530, time: "6:37 AM", students: 11 },
      { order: 8,  name: "BHEL Colony",         lat: 17.4648, lng: 78.3520, time: "6:43 AM", students: 8  },
      { order: 9,  name: "Telecom Nagar",       lat: 17.4668, lng: 78.3515, time: "6:49 AM", students: 7  },
      { order: 10, name: "Guttala Begumpet",    lat: 17.4675, lng: 78.3512, time: "6:54 AM", students: 8  },
      { order: 11, name: "Kondapur Main Road",  lat: 17.4680, lng: 78.3510, time: "6:57 AM", students: 7  },
      { order: 12, name: "School",              lat: SCHOOL_LAT, lng: SCHOOL_LNG, time: "7:00 AM", students: 0 },
    ],
  },
  {
    id: 6, name: "Route 6 — Kukatpally", busNumber: "TS-09-CG-2345",
    driver: "Anil Gupta", driverPhone: "9876543215", departure: "7:05 AM", status: "On time",
    stops: [
      { order: 1, name: "Kukatpally Housing Board", lat: 17.4948, lng: 78.4145, time: "6:35 AM", students: 10 },
      { order: 2, name: "BHEL X Roads",             lat: 17.4890, lng: 78.4080, time: "6:41 AM", students: 9  },
      { order: 3, name: "Moosapet",                 lat: 17.4835, lng: 78.4010, time: "6:47 AM", students: 8  },
      { order: 4, name: "Balanagar",                lat: 17.4775, lng: 78.3942, time: "6:53 AM", students: 10 },
      { order: 5, name: "Sanathnagar",              lat: 17.4725, lng: 78.3875, time: "6:59 AM", students: 9  },
      { order: 6, name: "SR Nagar",                 lat: 17.4700, lng: 78.3750, time: "7:06 AM", students: 8  },
      { order: 7, name: "School",                   lat: SCHOOL_LAT, lng: SCHOOL_LNG, time: "7:20 AM", students: 0 },
    ],
  },
  {
    id: 7, name: "Route 7 — Manikonda", busNumber: "TS-09-CH-6789",
    driver: "Deepak Yadav", driverPhone: "9876543216", departure: "7:20 AM", status: "On time",
    stops: [
      { order: 1, name: "Manikonda Village",    lat: 17.4126, lng: 78.3892, time: "6:45 AM", students: 6 },
      { order: 2, name: "Lanco Hills Township", lat: 17.4185, lng: 78.3840, time: "6:51 AM", students: 5 },
      { order: 3, name: "Puppalaguda Junction", lat: 17.4248, lng: 78.3785, time: "6:57 AM", students: 5 },
      { order: 4, name: "Nanakramguda",         lat: 17.4312, lng: 78.3730, time: "7:03 AM", students: 6 },
      { order: 5, name: "Gachibowli Road",      lat: 17.4385, lng: 78.3672, time: "7:09 AM", students: 5 },
      { order: 6, name: "Serilingampally",      lat: 17.4488, lng: 78.3615, time: "7:14 AM", students: 6 },
      { order: 7, name: "Kondapur Main Road",   lat: 17.4575, lng: 78.3558, time: "7:18 AM", students: 5 },
      { order: 8, name: "Laxmi Cyber City",     lat: 17.4632, lng: 78.3528, time: "7:22 AM", students: 7 },
      { order: 9, name: "School",               lat: SCHOOL_LAT, lng: SCHOOL_LNG, time: "7:30 AM", students: 0 },
    ],
  },
];

const EMPTY_FORM = { name: "", stops: "", busNumber: "", driver: "", driverPhone: "", departure: "", students: "", status: "On time" };

function busIcon(color) {
  return L.divIcon({
    className: "",
    html: `<div style="background:${color};width:34px;height:34px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:18px;box-shadow:0 2px 8px rgba(0,0,0,0.35);border:3px solid #fff;">🚌</div>`,
    iconSize: [34, 34], iconAnchor: [17, 17],
  });
}

function schoolIcon() {
  return L.divIcon({
    className: "",
    html: `<div style="background:#2563eb;width:40px;height:40px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:20px;box-shadow:0 2px 10px rgba(37,99,235,0.5);border:3px solid #fff;">🏫</div>`,
    iconSize: [40, 40], iconAnchor: [20, 20],
  });
}

/** Red marker for REAL live buses streamed from the transport app via Firestore. */
function liveBusIcon() {
  return L.divIcon({
    className: "",
    html: `<div style="position:relative;width:40px;height:40px;">
      <div style="position:absolute;inset:0;background:#ef4444;border-radius:50%;opacity:0.35;animation:livePulse 1.4s ease-out infinite;"></div>
      <div style="position:absolute;inset:3px;background:#ef4444;width:34px;height:34px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:18px;border:3px solid #fff;box-shadow:0 2px 8px rgba(239,68,68,0.6);">🚌</div>
      <style>@keyframes livePulse{0%{transform:scale(0.8);opacity:0.5}100%{transform:scale(1.6);opacity:0}}</style>
    </div>`,
    iconSize: [40, 40], iconAnchor: [20, 20],
  });
}

function fmtEta(secs) {
  if (secs <= 0) return "Arrived";
  const m = Math.floor(secs / 60);
  const s = secs % 60;
  if (m === 0) return `${s}s`;
  return s === 0 ? `${m} min` : `${m}m ${s}s`;
}

function routeStudents(route) {
  return (route.stops || []).reduce((a, s) => a + (s.students || 0), 0);
}

class TransportManagementHome extends Component {
  constructor(props) {
    super(props);
    this.mapRef         = React.createRef();
    this.leafletMap     = null;
    this.busMarkers     = {};
    this.routePolylines = {};
    this.stopMarkers    = {};
    this.animInterval   = null;

    // Live-bus marker layer (real positions from Firestore).
    this.liveBusMarkers = {};
    this.unsubLiveBuses = null;

    this.state = {
      routes: [], // populated live from Firestore in componentDidMount
      showAddModal: false,
      showEditModal: false,
      showTrackingModal: false,
      showViewModal: false,
      editingRoute: null,
      viewingRoute: null,
      form: { ...EMPTY_FORM },
      formErrors: {},
      routeGeometries: {},
      busProgress: {},
      geometryLoading: false,
      selectedTrackingRoute: null,
      time: new Date(),
    };
  }

  // ─── OSRM ───────────────────────────────────────────────────────────────────

  fetchRouteGeometry = async (route) => {
    const coords = route.stops.map((s) => `${s.lng},${s.lat}`).join(";");
    const url    = `${OSRM_BASE}/${coords}?overview=full&geometries=geojson&steps=true`;
    try {
      const ctrl = new AbortController();
      const tid  = setTimeout(() => ctrl.abort(), 8000);
      const res  = await fetch(url, { signal: ctrl.signal });
      clearTimeout(tid);
      const data = await res.json();
      if (data.routes && data.routes[0]) {
        const r        = data.routes[0];
        const points   = r.geometry.coordinates.map(([lng, lat]) => [lat, lng]);
        const legDurs  = r.legs.map((l) => l.duration);
        const totalDur = legDurs.reduce((a, b) => a + b, 0);
        let cum = 0;
        const stopFracs = [0];
        legDurs.forEach((d) => { cum += d; stopFracs.push(cum / totalDur); });
        return { points, legDurs, stopFracs, totalDur };
      }
    } catch (_) { /* fall through to fallback */ }

    // Fallback: straight lines with equal time per leg
    const n         = route.stops.length;
    const points    = route.stops.map((s) => [s.lat, s.lng]);
    const legDurs   = Array(n - 1).fill(360);
    const totalDur  = legDurs.reduce((a, b) => a + b, 0);
    const stopFracs = route.stops.map((_, i) => i / (n - 1));
    return { points, legDurs, stopFracs, totalDur };
  };

  loadAllGeometries = async () => {
    this.setState({ geometryLoading: true });
    const results = await Promise.all(
      this.state.routes.map((r) => this.fetchRouteGeometry(r).then((geo) => ({ id: r.id, geo })))
    );
    const routeGeometries = {};
    const busProgress     = { ...this.state.busProgress };

    results.forEach(({ id, geo }) => {
      routeGeometries[id] = geo;
      const prog = busProgress[id]?.progress || 0.2;
      const ni   = geo.stopFracs.findIndex((f) => f > prog);
      const next = ni < 0 ? geo.stopFracs.length - 1 : ni;
      const pt   = Math.min(Math.round(prog * (geo.points.length - 1)), geo.points.length - 1);
      busProgress[id] = { progress: prog, ptIdx: pt, nextStopIdx: next, etaSec: this.calcEta(prog, geo.stopFracs[next]) };
    });

    this.setState({ routeGeometries, busProgress, geometryLoading: false }, () => {
      this.drawRoutes();
      this.syncMarkers();
    });
  };

  calcEta = (progress, nextFrac) =>
    Math.round((Math.max(0, nextFrac - progress) / ADVANCE) * (TICK_MS / 1000));

  // ─── Map ────────────────────────────────────────────────────────────────────

  drawRoutes = () => {
    if (!this.leafletMap) return;
    const { routes, routeGeometries } = this.state;

    routes.forEach((route, idx) => {
      const color = BUS_COLORS[idx % BUS_COLORS.length];
      const geo   = routeGeometries[route.id];
      if (!geo) return;

      if (this.routePolylines[route.id]) this.routePolylines[route.id].remove();
      if (this.stopMarkers[route.id])    this.stopMarkers[route.id].forEach((m) => m.remove());

      this.routePolylines[route.id] = L.polyline(geo.points, {
        color, weight: 3.5, opacity: 0.55, smoothFactor: 1,
      }).addTo(this.leafletMap);

      // Stop circles (skip last = school, already shown)
      this.stopMarkers[route.id] = route.stops.slice(0, -1).map((stop) =>
        L.circleMarker([stop.lat, stop.lng], {
          radius: 5, fillColor: color, color: "#fff", weight: 2, opacity: 1, fillOpacity: 0.85,
        })
          .addTo(this.leafletMap)
          .bindPopup(
            `<b>Stop ${stop.order}: ${stop.name}</b><br>Scheduled: ${stop.time}<br>${stop.students} students boarding`
          )
      );
    });
  };

  syncMarkers = () => {
    const { routes, busProgress, routeGeometries } = this.state;
    routes.forEach((route) => {
      const bp  = busProgress[route.id];
      const geo = routeGeometries[route.id];
      if (bp && geo && geo.points[bp.ptIdx] && this.busMarkers[route.id]) {
        this.busMarkers[route.id].setLatLng(geo.points[bp.ptIdx]);
      }
    });
  };

  initMap = () => {
    if (this.leafletMap || !this.mapRef.current) return;

    this.leafletMap = L.map(this.mapRef.current, {
      center: [SCHOOL_LAT, SCHOOL_LNG], zoom: 12, zoomControl: true,
    });

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: '© <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
      maxZoom: 19,
    }).addTo(this.leafletMap);

    L.marker([SCHOOL_LAT, SCHOOL_LNG], { icon: schoolIcon() })
      .addTo(this.leafletMap)
      .bindPopup("<b>School</b>");

    // Draw the static route lines + stop dots from live Firestore routes.
    this.drawRoutePolylines();
    // Draw the moving live buses (and keep them updated as state.routes changes).
    this.drawLiveBusesFromRoutes();
  };

  /** Draw each route's polyline and stop markers from live route data. */
  drawRoutePolylines = () => {
    if (!this.leafletMap) return;
    this.state.routes.forEach((route, idx) => {
      if (this.routePolylines[route.id] || !route.stops.length) return;
      const color = route.color || BUS_COLORS[idx % BUS_COLORS.length];
      const pts = route.stops.map((s) => [s.lat, s.lng]);
      this.routePolylines[route.id] = L.polyline(pts, {
        color, weight: 4, opacity: 0.8,
      }).addTo(this.leafletMap);

      this.stopMarkers[route.id] = route.stops.map((stop) =>
        L.circleMarker([stop.lat, stop.lng], {
          radius: 5, color: "#fff", weight: 2, fillColor: color, fillOpacity: 1,
        })
          .addTo(this.leafletMap)
          .bindPopup(`<b>${stop.name}</b><br>${stop.time || ""}`)
      );
    });
  };

  /** Draw/update the real live buses, derived from each route's `live` field. */
  drawLiveBusesFromRoutes = () => {
    if (!this.leafletMap) return;
    this.drawRoutePolylines(); // pick up any newly-arrived routes
    const seen = new Set();

    this.state.routes.forEach((route) => {
      if (!route.live) return;
      seen.add(route.id);
      const pos = [route.live.lat, route.live.lng];
      const popup = `<b>🔴 LIVE — ${route.live.busNo || route.busNumber}</b><br>${route.name}<br>Driver: ${
        route.live.driverName || route.driver
      }<br>Speed: ${route.live.speed != null ? Math.round(route.live.speed * 3.6) : 0} km/h`;
      if (this.liveBusMarkers[route.id]) {
        const m = this.liveBusMarkers[route.id];
        m.setLatLng(pos);
        const p = m.getPopup();
        if (p) p.setContent(popup);
      } else {
        this.liveBusMarkers[route.id] = L.marker(pos, { icon: liveBusIcon() })
          .addTo(this.leafletMap)
          .bindPopup(popup);
      }
    });

    // Remove markers for routes whose trip ended.
    Object.keys(this.liveBusMarkers).forEach((id) => {
      if (!seen.has(id)) {
        this.leafletMap.removeLayer(this.liveBusMarkers[id]);
        delete this.liveBusMarkers[id];
      }
    });
  };

  /** Draw/update real live buses on the map from Firestore. */
  drawLiveBuses = (buses) => {
    if (!this.leafletMap) return;
    const running = buses.filter((b) => b && b.tripStatus === "running" && b.location);
    const seen = new Set();

    running.forEach((b) => {
      seen.add(b.vehicleId);
      const pos = [b.location.latitude, b.location.longitude];
      const popup = `<b>🔴 LIVE — ${b.busNo}</b><br>Driver: ${b.driverName || "—"}<br>Speed: ${
        b.speed != null ? Math.round(b.speed * 3.6) : 0
      } km/h`;
      if (this.liveBusMarkers[b.vehicleId]) {
        const m = this.liveBusMarkers[b.vehicleId];
        m.setLatLng(pos);
        const p = m.getPopup();
        if (p) p.setContent(popup);
      } else {
        this.liveBusMarkers[b.vehicleId] = L.marker(pos, { icon: liveBusIcon() })
          .addTo(this.leafletMap)
          .bindPopup(popup);
      }
    });

    // Remove markers for buses that are no longer running.
    Object.keys(this.liveBusMarkers).forEach((id) => {
      if (!seen.has(id)) {
        this.leafletMap.removeLayer(this.liveBusMarkers[id]);
        delete this.liveBusMarkers[id];
      }
    });
  };

  animateBuses = () => {
    const { routes, routeGeometries, busProgress: prev } = this.state;
    const next = {};

    routes.forEach((route) => {
      const geo = routeGeometries[route.id];
      const bp  = prev[route.id];
      if (!geo || !bp) return;

      let progress = bp.progress + ADVANCE;
      if (progress >= 1) progress = 0;

      const ptIdx = Math.min(Math.round(progress * (geo.points.length - 1)), geo.points.length - 1);
      let ni = geo.stopFracs.findIndex((f) => f > progress);
      if (ni < 0) ni = geo.stopFracs.length - 1;

      next[route.id] = { progress, ptIdx, nextStopIdx: ni, etaSec: this.calcEta(progress, geo.stopFracs[ni]) };
    });

    this.setState({ busProgress: next, time: new Date() }, () => {
      Object.keys(this.busMarkers).forEach((id) => {
        const bp  = this.state.busProgress[parseInt(id)];
        const geo = this.state.routeGeometries[parseInt(id)];
        if (bp && geo && geo.points[bp.ptIdx]) {
          this.busMarkers[id].setLatLng(geo.points[bp.ptIdx]);
        }
      });
    });
  };

  handleSelectRoute = (routeId) => {
    const deselect = this.state.selectedTrackingRoute === routeId;
    const newSel   = deselect ? null : routeId;
    this.setState({ selectedTrackingRoute: newSel }, () => {
      Object.keys(this.routePolylines).forEach((id) => {
        const active = !newSel || parseInt(id) === newSel;
        this.routePolylines[id].setStyle({ opacity: active ? 0.85 : 0.15, weight: active ? 5 : 2.5 });
      });
      if (newSel && this.leafletMap) {
        const bp  = this.state.busProgress[newSel];
        const geo = this.state.routeGeometries[newSel];
        if (bp && geo && geo.points[bp.ptIdx]) {
          this.leafletMap.panTo(geo.points[bp.ptIdx], { animate: true });
        }
      }
    });
  };

  destroyMap = () => {
    if (this.animInterval) { clearInterval(this.animInterval); this.animInterval = null; }
    if (this.unsubLiveBuses) { this.unsubLiveBuses(); this.unsubLiveBuses = null; }
    if (this.leafletMap) {
      Object.values(this.routePolylines).forEach((pl) => pl.remove());
      Object.values(this.stopMarkers).forEach((arr) => arr.forEach((m) => m.remove()));
      this.routePolylines = {};
      this.stopMarkers    = {};
      this.leafletMap.remove();
      this.leafletMap = null;
      this.busMarkers = {};
      this.liveBusMarkers = {};
    }
  };

  handleTrackingOpen = () => {
    this.setState({ showTrackingModal: true, selectedTrackingRoute: null }, () => {
      setTimeout(this.initMap, 200);
    });
  };

  handleTrackingClose = () => {
    this.destroyMap();
    this.setState({ showTrackingModal: false });
  };

  componentDidMount() {
    // firebase removed — live Firestore transport tracking disabled.
    // this.unsubData = subscribeTransportData((routes) => {
    //   this.setState({ routes }, () => {
    //     // If the live map is open, refresh its live-bus markers.
    //     if (this.leafletMap) this.drawLiveBusesFromRoutes();
    //   });
    // });
    // Tick the clock once a second for the "Live Tracking" header time.
    this.clockTimer = setInterval(() => this.setState({ time: new Date() }), 1000);
  }

  componentWillUnmount() {
    this.destroyMap();
    if (this.unsubData) { this.unsubData(); this.unsubData = null; }
    if (this.clockTimer) { clearInterval(this.clockTimer); this.clockTimer = null; }
  }

  // ─── Totals ──────────────────────────────────────────────────────────────────

  getTotals = () => {
    const { routes } = this.state;
    return {
      totalRoutes: routes.length,
      buses:       routes.length + 2,
      students:    routes.reduce((a, r) => a + routeStudents(r), 0),
      onRoad:      routes.filter((r) => r.status === "On time").length,
    };
  };

  // ─── Form ────────────────────────────────────────────────────────────────────

  handleFormChange = (field, value) => {
    this.setState((prev) => ({
      form: { ...prev.form, [field]: value },
      formErrors: { ...prev.formErrors, [field]: undefined },
    }));
  };

  validateForm = () => {
    const { form } = this.state;
    const errors   = {};
    if (!form.name.trim())                         errors.name      = "Route name is required";
    if (!form.stops || isNaN(Number(form.stops)))  errors.stops     = "Valid stop count required";
    if (!form.busNumber.trim())                    errors.busNumber = "Bus number is required";
    if (!form.driver.trim())                       errors.driver    = "Driver name is required";
    if (!form.departure.trim())                    errors.departure = "Departure time is required";
    if (!form.students || isNaN(Number(form.students))) errors.students = "Valid student count required";
    this.setState({ formErrors: errors });
    return Object.keys(errors).length === 0;
  };

  handleAddRoute = () => {
    if (!this.validateForm()) return;
    const { form } = this.state;
    const lat = SCHOOL_LAT + (Math.random() - 0.5) * 0.1;
    const lng = SCHOOL_LNG + (Math.random() - 0.5) * 0.15;
    const newRoute = {
      ...form, id: Date.now(),
      stops: [
        { order: 1, name: "Starting Point", lat, lng, time: form.departure, students: Number(form.students) },
        { order: 2, name: "School", lat: SCHOOL_LAT, lng: SCHOOL_LNG, time: "7:30 AM", students: 0 },
      ],
    };
    this.setState((prev) => ({
      routes:      [...prev.routes, newRoute],
      busProgress: { ...prev.busProgress, [newRoute.id]: { progress: 0.1, ptIdx: 0, nextStopIdx: 1, etaSec: 300 } },
      showAddModal: false,
      form: { ...EMPTY_FORM },
      formErrors: {},
    }));
  };

  handleEditRoute = () => {
    if (!this.validateForm()) return;
    const { form, routes, editingRoute } = this.state;
    const updated = routes.map((r) =>
      r.id === editingRoute.id ? { ...r, ...form, stops: r.stops } : r
    );
    this.setState({ routes: updated, showEditModal: false, editingRoute: null, form: { ...EMPTY_FORM }, formErrors: {} });
  };

  openEdit = (route) => {
    this.setState({
      editingRoute: route,
      form: {
        name: route.name, stops: String((route.stops?.length || 1) - 1),
        busNumber: route.busNumber, driver: route.driver,
        driverPhone: route.driverPhone || "", departure: route.departure,
        students: String(routeStudents(route)), status: route.status,
      },
      formErrors: {},
      showEditModal: true,
    });
  };

  getStatusBadge = (status) => {
    if (status === "On time")                   return <span className="tm-badge tm-badge-success">{status}</span>;
    if (status.toLowerCase().includes("delay")) return <span className="tm-badge tm-badge-warning">{status}</span>;
    return <span className="tm-badge tm-badge-danger">{status}</span>;
  };

  renderFormFields = () => {
    const { form, formErrors } = this.state;
    const fields = [
      { label: "Route Name",   key: "name",       type: "text",   placeholder: "e.g. Route 1 — KPHB Colony" },
      { label: "Stops",        key: "stops",      type: "number", placeholder: "8" },
      { label: "Bus Number",   key: "busNumber",  type: "text",   placeholder: "TS-09-CA-1234" },
      { label: "Driver Name",  key: "driver",     type: "text",   placeholder: "Full name" },
      { label: "Driver Phone", key: "driverPhone",type: "tel",    placeholder: "10-digit number", optional: true },
      { label: "Departure",    key: "departure",  type: "text",   placeholder: "7:00 AM" },
      { label: "Students",     key: "students",   type: "number", placeholder: "72" },
    ];
    return (
      <>
        {fields.map(({ label, key, type, placeholder, optional }) => (
          <Form.Group as={Row} className="mb-2 align-items-center" key={key}>
            <Form.Label column sm={4} className="tm-form-label">{label}</Form.Label>
            <Col sm={8}>
              <Form.Control
                type={type} value={form[key]} placeholder={placeholder} size="sm"
                onChange={(e) => this.handleFormChange(key, e.target.value)}
                isInvalid={!optional && !!formErrors[key]}
              />
              {!optional && formErrors[key] && <div className="tm-field-error">{formErrors[key]}</div>}
            </Col>
          </Form.Group>
        ))}
        <Form.Group as={Row} className="mb-2 align-items-center">
          <Form.Label column sm={4} className="tm-form-label">Status</Form.Label>
          <Col sm={8}>
            <Form.Control as="select" size="sm" value={form.status}
              onChange={(e) => this.handleFormChange("status", e.target.value)}>
              <option>On time</option>
              <option>Delayed 10min</option>
              <option>Delayed 20min</option>
              <option>Not departed</option>
            </Form.Control>
          </Col>
        </Form.Group>
      </>
    );
  };

  // ─── Tracking panel ──────────────────────────────────────────────────────────

  renderBusList = () => {
    const { routes, busProgress, routeGeometries, geometryLoading } = this.state;
    return (
      <>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
          <span className="tm-tracking-panel-title" style={{ margin: 0 }}>Active Buses</span>
          {geometryLoading && <span style={{ fontSize: 10, color: "#9aa5b4", fontStyle: "italic" }}>Loading routes…</span>}
        </div>

        {routes.length === 0 && (
          <div style={{ fontSize: 12, color: "#9aa5b4", padding: "12px 4px" }}>
            Loading routes from the cloud…
          </div>
        )}
        {routes.map((route, idx) => {
          const color    = route.color || BUS_COLORS[idx % BUS_COLORS.length];
          const live     = route.live;
          // Progress = how far along the stops the live bus is.
          const progress = live && route.stops.length > 1
            ? live.currentStopIndex / (route.stops.length - 1) : 0;
          const nextStop = live ? route.stops[live.currentStopIndex] : null;

          return (
            <button key={route.id} type="button" className="tm-bus-btn"
              onClick={() => this.handleSelectRoute(route.id)}>
              <span className="tm-bus-btn-icon" style={{ background: live ? "#ef4444" : color }}>🚌</span>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div className="tm-bus-btn-name">
                  {route.name}
                  {live && <span style={{ marginLeft: 6, fontSize: 9, fontWeight: 800, color: "#ef4444" }}>● LIVE</span>}
                </div>
                <div className="tm-bus-btn-meta">{route.busNumber} · {route.driver}</div>
                <div className="tm-route-progress">
                  <div className="tm-route-progress-fill" style={{ width: `${(progress * 100).toFixed(1)}%`, background: live ? "#ef4444" : color }} />
                </div>
                {nextStop && (
                  <div style={{ display: "flex", alignItems: "center", gap: 5, marginTop: 4 }}>
                    <span className="tm-eta-pill" style={{ background: "#ef444418", color: "#ef4444" }}>
                      {live.speed != null ? Math.round(live.speed * 3.6) : 0} km/h
                    </span>
                    <span style={{ fontSize: 10, color: "#6b7280", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", flex: 1 }}>
                      → {nextStop.name}
                    </span>
                  </div>
                )}
                <div style={{ marginTop: 4 }}>{this.getStatusBadge(route.status)}</div>
              </div>
              <span style={{ fontSize: 14, color: "#9aa5b4", flexShrink: 0, alignSelf: "center" }}>›</span>
            </button>
          );
        })}

        <div className="tm-tracking-panel-title" style={{ marginTop: 14 }}>School</div>
        <div className="tm-legend-row">
          <span className="tm-legend-color" style={{ background: "#2563eb" }}>🏫</span>
          <div className="tm-legend-info">
            <div className="tm-legend-name">Kondapur Campus</div>
            <div className="tm-legend-meta">17.4688°N, 78.3513°E</div>
          </div>
        </div>
      </>
    );
  };

  renderRouteDetail = (routeId) => {
    const { routes, busProgress, routeGeometries } = this.state;
    const route = routes.find((r) => r.id === routeId);
    if (!route) return null;

    const idx   = routes.indexOf(route);
    const color = BUS_COLORS[idx % BUS_COLORS.length];
    const bp    = busProgress[routeId];
    const geo   = routeGeometries[routeId];

    return (
      <>
        <button type="button" className="tm-back-btn" onClick={() => this.handleSelectRoute(routeId)}>
          ← All Buses
        </button>

        {/* Route header card */}
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10, padding: 8, background: "#fff", borderRadius: 8, border: "1px solid #e5e7eb" }}>
          <span style={{ width: 32, height: 32, borderRadius: "50%", background: color, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16, flexShrink: 0, border: "2px solid #fff", boxShadow: "0 1px 4px rgba(0,0,0,0.2)" }}>🚌</span>
          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: "#1a2332", lineHeight: 1.2, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{route.name}</div>
            <div style={{ fontSize: 10.5, color: "#9aa5b4" }}>{route.busNumber} · {route.driver}</div>
            <div style={{ fontSize: 10.5, color: "#9aa5b4" }}>📞 {route.driverPhone}</div>
          </div>
        </div>

        {/* Quick stats */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 5, marginBottom: 10 }}>
          {[["Pickup Stops", route.stops.length - 1], ["Students", routeStudents(route)], ["Departure", route.departure], ["Status", null]].map(([label, val]) => (
            <div key={label} style={{ background: "#fff", borderRadius: 6, padding: "5px 8px", border: "1px solid #e5e7eb" }}>
              <div style={{ fontSize: 9, fontWeight: 700, color: "#9aa5b4", textTransform: "uppercase", letterSpacing: 0.5 }}>{label}</div>
              {val === null
                ? <div style={{ marginTop: 2 }}>{this.getStatusBadge(route.status)}</div>
                : <div style={{ fontSize: 12, fontWeight: 700, color: "#1a2332", marginTop: 1 }}>{val}</div>
              }
            </div>
          ))}
        </div>

        {/* ETA banner */}
        {bp && geo && (
          <div style={{ background: `${color}12`, border: `1px solid ${color}35`, borderRadius: 8, padding: "8px 10px", marginBottom: 10 }}>
            <div style={{ fontSize: 9.5, fontWeight: 700, color, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 3 }}>Next Stop ETA</div>
            <div style={{ display: "flex", alignItems: "baseline", gap: 6, marginBottom: 6 }}>
              <span style={{ fontSize: 22, fontWeight: 800, color, fontFamily: "monospace", lineHeight: 1 }}>{fmtEta(bp.etaSec)}</span>
              <span style={{ fontSize: 11, color, fontWeight: 600, flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {route.stops[bp.nextStopIdx]?.name || "School"}
              </span>
            </div>
            <div className="tm-route-progress">
              <div className="tm-route-progress-fill" style={{ width: `${((bp.progress || 0) * 100).toFixed(1)}%`, background: color }} />
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", fontSize: 9, color: "#9aa5b4", marginTop: 2 }}>
              <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "40%" }}>{route.stops[0]?.name}</span>
              <span>{Math.round((bp.progress || 0) * 100)}% complete</span>
              <span>School</span>
            </div>
          </div>
        )}

        {/* Stop-by-stop list */}
        <div className="tm-tracking-panel-title">Route Stops</div>
        <div style={{ display: "flex", flexDirection: "column", paddingBottom: 12 }}>
          {route.stops.map((stop, i) => {
            const isPassed  = bp && i < bp.nextStopIdx;
            const isCurrent = bp && i === bp.nextStopIdx;
            const stopEtaSec = geo && bp && !isPassed
              ? Math.round((geo.stopFracs[i] - bp.progress) / ADVANCE * (TICK_MS / 1000))
              : null;

            return (
              <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: 8, paddingBottom: 6, position: "relative" }}>
                {i < route.stops.length - 1 && (
                  <div style={{ position: "absolute", left: 7, top: 18, bottom: -4, width: 2, background: isPassed ? color : "#e5e7eb" }} />
                )}
                <div style={{
                  width: 16, height: 16, borderRadius: "50%", flexShrink: 0, marginTop: 2,
                  background: isPassed ? color : isCurrent ? "#fff" : "#f3f4f6",
                  border: `${isCurrent ? 3 : 2}px solid ${(isPassed || isCurrent) ? color : "#d1d5db"}`,
                  boxShadow: isCurrent ? `0 0 0 3px ${color}33` : "none",
                }} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 11, fontWeight: isCurrent ? 700 : 600, color: isPassed ? "#9aa5b4" : "#1a2332", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {stop.name}
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: 4, flexWrap: "wrap" }}>
                    <span style={{ fontSize: 10, color: "#9aa5b4", fontFamily: "monospace" }}>{stop.time}</span>
                    {stop.students > 0 && <span style={{ fontSize: 10, color: "#6b7280" }}>· {stop.students} stu</span>}
                    {isCurrent && (
                      <span style={{ fontSize: 9, background: color, color: "#fff", fontWeight: 700, padding: "1px 5px", borderRadius: 6 }}>NEXT</span>
                    )}
                    {isPassed && <span style={{ fontSize: 10, color, fontWeight: 700 }}>✓</span>}
                    {!isPassed && !isCurrent && stopEtaSec !== null && stopEtaSec > 0 && (
                      <span style={{ fontSize: 9.5, color: "#9aa5b4" }}>~{fmtEta(stopEtaSec)}</span>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </>
    );
  };

  // ─── Render ──────────────────────────────────────────────────────────────────

  render() {
    const {
      routes, showAddModal, showEditModal, showTrackingModal,
      showViewModal, viewingRoute, time, selectedTrackingRoute,
    } = this.state;
    const { totalRoutes, buses, students, onRoad } = this.getTotals();
    const studentsPercent = Math.min(Math.round((students / 2400) * 100), 100);

    return (
      <div className="tm-root">

        {/* ── Header ── */}
        <div className="tm-page-header">
          <div>
            <h4 className="tm-page-title">Transport Management</h4>
            <p className="tm-page-subtitle">Bus routes, drivers, student allocation and live tracking</p>
          </div>
          <div className="tm-header-actions">
            <button type="button" className="tm-btn tm-btn-outline"
              onClick={() => this.setState({ showAddModal: true, form: { ...EMPTY_FORM }, formErrors: {} })}>
              <i className="fal fa-plus" /> Add Route
            </button>
            <button type="button" className="tm-btn tm-btn-primary" onClick={this.handleTrackingOpen}>
              <i className="fal fa-map-marker-alt" /> Live Tracking
            </button>
          </div>
        </div>

        {/* ── Stats ── */}
        <div className="tm-stats-grid">
          <div className="tm-stat-card">
            <div className="tm-stat-label">Total Routes</div>
            <div className="tm-stat-value">{totalRoutes}</div>
          </div>
          <div className="tm-stat-card">
            <div className="tm-stat-label">Buses</div>
            <div className="tm-stat-value">{buses}</div>
            <div className="tm-stat-sub-row"><span className="tm-dot" style={{ background: "#10b981" }} /><span>2 spare</span></div>
            <div className="tm-progress-bar"><div className="tm-progress-fill" style={{ width: `${((buses - 2) / buses) * 100}%`, background: "#10b981" }} /></div>
          </div>
          <div className="tm-stat-card">
            <div className="tm-stat-label">Students on Bus</div>
            <div className="tm-stat-value">{students}</div>
            <div className="tm-stat-sub-row"><span className="tm-dot" style={{ background: "#10b981" }} /><span>{studentsPercent}% of school</span></div>
            <div className="tm-progress-bar"><div className="tm-progress-fill" style={{ width: `${studentsPercent}%`, background: "#10b981" }} /></div>
          </div>
          <div className="tm-stat-card">
            <div className="tm-stat-label">On Road Now</div>
            <div className="tm-stat-value" style={{ color: "#10b981" }}>{onRoad}</div>
          </div>
        </div>

        {/* ── Table ── */}
        <div className="tm-table-card">
          <div className="tm-table-header">All Routes</div>
          <div className="tm-table-scroll">
            <table className="tm-table">
              <thead>
                <tr>
                  <th>ROUTE</th><th>STOPS</th><th>BUS NUMBER</th><th>DRIVER</th>
                  <th>DEPARTURE</th><th>STUDENTS</th><th>TODAY STATUS</th><th>ACTIONS</th>
                </tr>
              </thead>
              <tbody>
                {routes.map((route) => (
                  <tr key={route.id}>
                    <td className="tm-route-name">{route.name}</td>
                    <td className="tm-muted">{(route.stops?.length || 1) - 1} stops</td>
                    <td className="tm-mono">{route.busNumber}</td>
                    <td>{route.driver}</td>
                    <td style={{ color: "#2563eb", fontWeight: 600 }}>{route.departure}</td>
                    <td style={{ fontWeight: 600 }}>{routeStudents(route)}</td>
                    <td>{this.getStatusBadge(route.status)}</td>
                    <td>
                      <div className="tm-action-btns">
                        <button type="button" className="tm-icon-btn tm-blue" title="View"
                          onClick={() => this.setState({ viewingRoute: route, showViewModal: true })}>
                          <i className="fal fa-book-open" />
                        </button>
                        <button type="button" className="tm-icon-btn tm-orange" title="Edit" onClick={() => this.openEdit(route)}>
                          <i className="fal fa-pencil" />
                        </button>
                        <button type="button" className="tm-icon-btn tm-red" title="Call Driver"
                          onClick={() => window.open(`tel:${route.driverPhone}`)}>
                          <i className="fal fa-phone" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* ── Add Modal ── */}
        <Modal show={showAddModal} onHide={() => this.setState({ showAddModal: false })} centered size="md">
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: 16, fontWeight: 700 }}>
              <i className="fal fa-plus-circle mr-2 text-primary" />Add New Route
            </Modal.Title>
          </Modal.Header>
          <Modal.Body><Form>{this.renderFormFields()}</Form></Modal.Body>
          <Modal.Footer>
            <button type="button" className="tm-btn tm-btn-ghost" onClick={() => this.setState({ showAddModal: false })}>Cancel</button>
            <button type="button" className="tm-btn tm-btn-primary" onClick={this.handleAddRoute}>Add Route</button>
          </Modal.Footer>
        </Modal>

        {/* ── Edit Modal ── */}
        <Modal show={showEditModal} onHide={() => this.setState({ showEditModal: false })} centered size="md">
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: 16, fontWeight: 700 }}>
              <i className="fal fa-pencil mr-2 text-warning" />Edit Route
            </Modal.Title>
          </Modal.Header>
          <Modal.Body><Form>{this.renderFormFields()}</Form></Modal.Body>
          <Modal.Footer>
            <button type="button" className="tm-btn tm-btn-ghost" onClick={() => this.setState({ showEditModal: false })}>Cancel</button>
            <button type="button" className="tm-btn tm-btn-primary" onClick={this.handleEditRoute}>Update Route</button>
          </Modal.Footer>
        </Modal>

        {/* ── View Modal ── */}
        <Modal show={showViewModal} onHide={() => this.setState({ showViewModal: false })} centered size="md">
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: 16, fontWeight: 700 }}>
              <i className="fal fa-bus mr-2 text-primary" />Route Details
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {viewingRoute && (
              <div className="tm-detail-list">
                {[
                  ["Route Name",   viewingRoute.name],
                  ["Pickup Stops", (viewingRoute.stops?.length || 1) - 1],
                  ["Bus Number",   viewingRoute.busNumber],
                  ["Driver",       viewingRoute.driver],
                  ["Driver Phone", viewingRoute.driverPhone || "N/A"],
                  ["Departure",    viewingRoute.departure],
                  ["Students",     routeStudents(viewingRoute)],
                ].map(([label, value]) => (
                  <div className="tm-detail-row" key={label}>
                    <span className="tm-detail-label">{label}</span>
                    <span className="tm-detail-value">{value}</span>
                  </div>
                ))}
                <div className="tm-detail-row">
                  <span className="tm-detail-label">Status</span>
                  <span className="tm-detail-value">{this.getStatusBadge(viewingRoute.status)}</span>
                </div>
                {viewingRoute.stops?.length > 0 && (
                  <div className="tm-detail-row" style={{ flexDirection: "column", gap: 6 }}>
                    <span className="tm-detail-label" style={{ width: "auto", marginBottom: 4 }}>All Stops</span>
                    {viewingRoute.stops.map((stop) => (
                      <div key={stop.order} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: 12.5, padding: "5px 10px", background: "#f8f9fb", borderRadius: 6 }}>
                        <span style={{ fontWeight: 600, color: "#1a2332" }}>{stop.order}. {stop.name}</span>
                        <span style={{ color: "#9aa5b4", fontFamily: "monospace", fontSize: 11 }}>
                          {stop.time}{stop.students > 0 ? ` · ${stop.students} stu` : ""}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <button type="button" className="tm-btn tm-btn-ghost" onClick={() => this.setState({ showViewModal: false })}>Close</button>
            {viewingRoute && (
              <button type="button" className="tm-btn tm-btn-primary"
                onClick={() => { this.setState({ showViewModal: false }); this.openEdit(viewingRoute); }}>
                Edit Route
              </button>
            )}
          </Modal.Footer>
        </Modal>

        {/* ── Live Tracking Modal ── */}
        <Modal show={showTrackingModal} onHide={this.handleTrackingClose} centered size="xl" dialogClassName="tm-tracking-dialog">
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: 16, fontWeight: 700 }}>
              <span className="tm-live-dot" />
              <span style={{ marginLeft: 8 }}>Live Tracking — Kondapur, Hyderabad</span>
              <span className="tm-time-badge">{time.toLocaleTimeString()}</span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: 0 }}>
            <div style={{ display: "flex", height: 540 }}>
              <div ref={this.mapRef} style={{ flex: 1, minWidth: 0 }} />
              <div className="tm-tracking-panel">
                {selectedTrackingRoute
                  ? this.renderRouteDetail(selectedTrackingRoute)
                  : this.renderBusList()
                }
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button type="button" className="tm-btn tm-btn-ghost" onClick={this.handleTrackingClose}>Close</button>
          </Modal.Footer>
        </Modal>

      </div>
    );
  }
}

export default TransportManagementHome;
